import { _ } from "$json/lib/gettext";
/* translations:
 *
 * Provide own translation strings.
 *

 * Author: Niels Giesen
 * Copyright 2020 Berkeley Bridge
 *
 */

const translations = {
  "delete row": {
    nl: "verwijderen"
  }
};

_.addTranslations(translations);
